import backup from "./backup.component";
import backupUrls from "./backup.urls";
import BackupTransforms from "./backup.transforms";

const backupModule = angular
  .module("app.components.backup", [])
  .component("backupPage", backup)
  .service("BackupTransforms", BackupTransforms)
  .config(backupUrls);

export default backupModule;



// WEBPACK FOOTER //
// ./src/pages/backup/backup.module.js